import { kebabCase } from "../../utilities/string.js";
const setTransitionalStyle = ({ element, transitionalStyle, finalStyle })=>{
    for (const [key, value] of Object.entries('function' == typeof transitionalStyle ? transitionalStyle() : transitionalStyle))element.style.setProperty(kebabCase(key), value);
    requestAnimationFrame(()=>{
        requestAnimationFrame(()=>{
            for (const [key, value] of Object.entries('function' == typeof finalStyle ? finalStyle() : finalStyle))element.style.setProperty(kebabCase(key), value);
        });
    });
};
export { setTransitionalStyle };
